<template>
  <!-- 确认订单 -->
  <div class="confirm-page" v-cloak>
    <van-nav-bar title="确认订单" fixed left-arrow @click-left="onleft"></van-nav-bar>

    <!-- 没有地址 -->
    <!-- <div class="no-address" v-if="addreList.length == 0" @click="goAdd">
      <van-icon name="location-o" class="mr10" size="17" />
      您还没有收货地址，请添加收货地址
    </div> -->

    <!-- 有地址 -->
    <!-- <div class="header-address" v-else @click="onAdderss">
      <div class="header-address-name">
        <span class="moren" v-if="addreItem.is_default == 1">默认</span>{{ addreItem.contacts }}{{ addreItem.phone }}
      </div>
      <div class="header-address-city">{{ addreItem.region }}</div>
      <div class="header-address-in">{{ addreItem.address }}</div>
    </div> -->

    <!-- 商品 -->
    <div class="goods" v-for="(item, index) in goodsInfo" :key="index">
      <!-- 
         //   goods_name: "商品名称",
          //   activity_type: "类型；1普通 2礼券 3积分 4兑换",
          //   express_price: "快递费",
          //   pic: "主图片",
          //   brand_name: "品牌名称",
          //   province_name: "所在省",
          //   city_name: "所在市",
          //   market_price: "市场价",
          //   shop_price: "价格",
          //   sku_id: "sku_id",
          //   spec_value: "spec_value",
          //   spec_value: "蓝色,LNR1510",
          //   spec_value_ids: "1,3",
          //   stock: "库存",
          //   goods_id: "goods_id",
          //   amount: "amount", //数量
       -->
      <!-- 商品信息 -->
      <div class="goods-info-block">
        <div class="goods-top">
          <van-image class="img" :src="item.pic" />
          <div class="info-block">
            <div class="name">{{ item.brand_name }} {{ item.goods_name }}</div>
            <div class="desc" v-if="item.province_name">{{ item.province_name }}-{{ item.city_name }}
            </div>
            <p class="udc">{{ item.spec_value }}</p>
            <div class="price-block">
              <div class="price-tips">￥{{ item.market_price }}</div>
              <div class="price">￥{{ item.shop_price }}</div>
            </div>
          </div>
        </div>
        <!-- 数量 -->
        <!-- <div class="goods-num">
          <p class="num-title">数量</p> 
          <van-stepper v-model="item.amount" theme="round" button-size="22" disable-input />
        </div> -->

        <div class="goods-num" v-if="item.type == 1">
          <!-- 礼券 -->
          <p class="num-title">数量 <span>礼券：1，限购：1</span></p>
          <van-stepper v-model="item.amount" theme="round" :disabled="true" button-size="22" disable-input />
        </div>
        <div class="goods-num" v-if="item.type == 2">
          <!-- //积分  -->
          <p class="num-title">数量 <span>积分：{{expoints}}，限购：{{item.limitAmount}}</span></p>
          <van-stepper v-model="item.amount" theme="round" :max="item.limitAmount" :min="1" button-size="22" disable-input />
        </div>

      </div>
      <!-- 小计 -->
      <div class="total-block">
        <div class="total-left">
          <p class="total-tips">共{{ item.amount }}件</p>
          <p>小计</p>
        </div>
        <div class="total-right"><span>¥</span> {{ jsMathFloor(item.amount * item.shop_price )}}</div>
      </div>
    </div>

    <!-- 总计 -->
    <div class="goods-cell">
      <!-- <div class="cell-block">
        <div class="cell-title">优惠卷</div>
        <div class="cell-center">- 22222</div>
      </div> -->

      <div class="cell-block">
        <div class="cell-title">
          运费
        </div>
        <div class="cell-center" v-if="freightMoney > 0">￥{{freightMoney}}</div>
        <div class="cell-center" v-else>0.00</div>

      </div>
    </div>

    <div class="address-block">
      <van-cell-group>
        <van-field v-model="addreItem.contacts" label="姓名" placeholder="请输入姓名" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="addreItem.phone" label="手机号" placeholder="请输入手机号" />
      </van-cell-group>
      <van-field readonly clickable name="picker" :value="addreItem.region" label="省市区" placeholder="点击选择城市" @click="IsShow = true" />
      <van-cell-group>
        <van-field v-model="addreItem.post_code" label="邮编" placeholder="请输入邮编" />
      </van-cell-group>
      <van-field v-model="addreItem.address" rows="2" autosize label="详细地址" type="textarea" maxlength="50" placeholder="请输入详细地址" show-word-limit />
    </div>
    <!-- 
      goods:兑换商品,json字符串
      company_id:公司id
      type:1=礼券兑换 2=积分兑换
      contacts:收件人
      phone:收件人电话
      address:地址
      pid:省code
      cid:市code
      aid:区code
      region:省市区
      post_code:邮政编码
      user_note:备注
     -->

    <!-- 备注 -->
    <div class="input-block">
      <p class="tips">备注信息</p>
      <van-field v-model="remark" rows="1" autosize type="textarea" maxlength="50" placeholder="请输入备注信息" show-word-limit />
    </div>

    <!-- 底部按钮 -->
    <div class="foot-block">
      <div class="foot-left">
        <span class="foot-tips">总计：</span>
        <span class="foot-icon">¥</span>
        <span v-if="freightMoney > 0">{{ jsMathFloorSS(totalMoney , freightMoney)}}</span>
        <span v-else>{{ jsMathFloor(totalMoney) }}</span>
      </div>
      <div class="btn pay btn-a" @click="isProvinces">提交订单</div>
    </div>

    <!-- 支付弹窗 -->
    <van-popup v-model="isPayPop" position="bottom" round :style="{ height: '40%' }" @close="clickClose()">
      <div class="pop-pay-header">
        <h3>确定支付</h3>
        <p class="pop-pay-price"><span>¥</span> {{jsMathFloor(orderInfo.order_amount)}}</p>
        <p class="pop-pay-time">支付剩余时间：
          <van-count-down :time="time">
            <template #default="timeData">
              <span class="block">{{ timeData.hours }}</span>
              <span class="colon">:</span>
              <span class="block">{{ timeData.minutes }}</span>
              <span class="colon">:</span>
              <span class="block">{{ timeData.seconds }}</span>
            </template>
          </van-count-down>
        </p>
      </div>

      <!-- <div class="pop-pay-center">
        <div class="pop-pay-cell mb20" @click="replacePayMethod(true)">
          <div class="pop-pay-left">
            余额抵扣可用¥{{ jsMathFloor(points)}}
          </div>
          <div class="radio">
            <img class="radio-icon" :src="isPayMethod ? radio_active_icon : radio_icon" />
          </div>
        </div>

        <div class="pop-pay-cell" @click="replacePayMethod(false)">
          <div class="pop-pay-left">
            不使用余额抵扣
          </div>
          <div class="radio">
            <img class="radio-icon" :src="!isPayMethod ? radio_active_icon : radio_icon" />
          </div>
        </div>
      </div> -->

      <div class="pop-pay-btn-block">
        <div class="pop-pay-btn btn-a" @click="LinshiTzhaun">确认支付</div>
        <!-- <div class="pop-pay-btn btn-a" v-if="orderInfo.order_amount >= points" @click="LinshiTzhaun">余额抵扣¥0,剩余支付¥{{ jsMathFloor(orderInfo.order_amount) }}</div> -->
        <!-- <div class="pop-pay-btn btn-a" v-if="orderInfo.order_amount >= points" @click="goPayresult">余额抵扣¥{{  jsMathFloor(points) }},剩余支付¥{{ jsMathFloor(orderInfo.order_amount - points) }}</div> -->
        <!-- <div class="pop-pay-btn btn-a" v-else-if="orderInfo.order_amount < points" @click="goPointsPay">余额抵扣¥{{  jsMathFloor(orderInfo.order_amount) }},剩余支付¥0.00</div> -->
      </div>

    </van-popup>
    <!-- 支付弹窗 end -->

    <van-popup v-model="IsShow" position="bottom">
      <van-area title="选择地址" @confirm="onConfirm" @cancel="IsShow = false" :value="addreItem.aid" :area-list="areaList" />
    </van-popup>

  </div>
</template>

<script type="text/babel">
let areaData = require("../../utils/area.js"); //根据需求改成你自己的路径
import wx from "weixin-js-sdk";
export default {
  name: "ConfirmOrder",
  components: {},
  props: {},
  data() {
    return {
      areaList: areaData.default,
      IsShow: false,

      company_id: this.$route.query.company_id,
      productType: this.$route.query.type,

      time: 60 * 30 * 1000,
      // isPayMethod: true, //支付方式
      isPayPop: false, //支付弹窗
      isAdderssPop: false, // 地址弹窗
      active: 0,
      radio_icon: require("../../assets/icon/radio.png"), //radio
      radio_active_icon: require("../../assets/icon/radio-active.png"), //radio active
      addreList: [],
      addreItem: {
        region: "",
        pid: "", // 省Id
        cid: "", // 市
        aid: "310101", // 区
        address: "", //详细地址
        contacts: "", //联系人
        phone: "", //联系电话
        post_code: "", //邮政编码

        // user_note:备注
      },
      remark: "", //备注信息
      goodsInfo: Lockr.get("birthConfirmGoodsInfo"), //商品详情

      totalMoney: 0, //合计现金总额
      skuList: [],

      // 订单后数据
      orderInfo: {
        order_sn: "",
        order_amount: 0,
        state: 0,
        pay: "",
      },
      points: 0, //用户积分

      freightMoney: 0, //邮费

      expoints: 0,
    };
  },
  watch: {
    goodsInfo: {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue);
        this.count(); //计算总价
      },
      deep: true, // 深度监听表单
    },
  },
  created() {},
  mounted() {
    console.log(Lockr.get("birthConfirmGoodsInfo"));
    // this.initAddreData();
    this.count(); //计算总价
    this.getPoints(); //用户积分
    // this.getChannelMoney() //初始化包邮、运费
  },
  methods: {
    onConfirm(value) {
      // console.log(value)
      // this.value = value;
      this.addreItem.region =
        value[0].name + "/" + value[1].name + "/" + value[2].name; //前置地址
      this.addreItem.pid = value[0].code; //省
      this.addreItem.cid = value[1].code; //市
      this.addreItem.aid = value[2].code; //区
      this.IsShow = false;
    },
    // 初始化地址列表数据
    // initAddreData() {
    //   let _this = this;
    //   let data = {
    //     uid: Lockr.get("userId"), // uid
    //   };
    //   this.$post("/api/user_address", data, data).then((res) => {
    //     console.log(res.data.data, "地址表");
    //     if (res.data.code == 0) {
    //       if (res.data.data.length > 0) {
    //         _this.addreList = res.data.data;
    //         _this.addreItem = res.data.data[0];
    //       } else {
    //         _this.addreList = [];
    //         _this.addreItem = {};
    //       }
    //     } else {
    //       this.$toast.fail(res.data.message);
    //     }
    //   });
    // },
    // 初始化包邮、运费
    getChannelMoney() {
      let _this = this;
      this.$get("/order/api/Order/ChannelMoney", { Page: 1, Size: 1000 }).then(
        (res) => {
          console.log(res.data.data, "包邮、运费");
          if (res.data.code == 200) {
            _this.freeMoney = res.data.data.freeMoney || 0; // 起包邮价
            _this.freightMoney = res.data.data.freightMoney || 0; // 邮费
          } else {
            this.$toast.fail(res.data.message);
          }
        }
      );
    },
    // 选择地址
    // setType(index, e) {
    //   this.addreItem = e;
    //   this.active = index;

    //   this.onAdderss();
    // },
    // 新增地址
    // goAdd() {
    //   this.$router.push({
    //     name: "adderss-edit",
    //     query: {
    //       isPage: 1,
    //     },
    //   });
    // },
    // 验证操作
    isProvinces() {
      let _this = this;
      if (!_this.addreItem.contacts) {
        this.$toast.fail("联系人姓名不可为空！");
        return;
      } else if (!/^1[3456789]\d{9}$/.test(_this.addreItem.phone)) {
        this.$toast.fail("联系电话错误！请重新填写");
        return;
      } else if (!_this.addreItem.region) {
        this.$toast.fail("请选择省市区！");
        return;
      } else if (!_this.addreItem.address) {
        this.$toast.fail("请填写详细地址！");
        return;
      }

      _this.onPay();
    },

    // 支付
    onPay() {
      let _this = this;
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      let ddd = JSON.stringify(_this.skuList);
      let param = Object.assign(
        {
          goods: ddd,
          user_note: this.remark,
          company_id: this.company_id,
          type: this.productType,
        },
        this.addreItem
      );

      this.$post("/api/birth_create_order", param, param).then((res) => {
        // console.log(res);
        _this.$toast.clear(); //关闭弹窗
        if (res.data.code == 0) {
          console.log(res.data.data, "创建订单");
          _this.$toast.success(res.data.message);
          // this.orderInfo = res.data.data;
          _this.$router.replace({
            name: "pay-result",
            query: {
              isType: 1,
            },
          });
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
      //
    },
    // 临时跳转
    LinshiTzhaun() {
      window.location.href = this.orderInfo.pay;
    },
    // 积分支付
    // goPointsPay() {
    //   let _this = this;
    //   //下单
    //   _this
    //     .$post("/order/api/Pay", {
    //       orderId: _this.orderInfo.order_sn,
    //       // wechatAmount: p_wechatAmount,
    //       // jxPoints: p_jxPoints,
    //       openId: Lockr.get("openId") || "",
    //     })
    //     .then((res) => {
    //       console.log(res);
    //       if (res.data.code == 200) {
    //         console.log(res.data.data);

    //         console.log("积分支付");
    //         _this.$toast.success("支付成功");
    //         _this.$router.replace({
    //           name: "pay-result",
    //           query: {
    //             isType: 1,
    //           },
    //         });
    //       } else {
    //         _this.$toast.fail(res.data.message);
    //         _this.$router.replace({
    //           name: "pay-result",
    //           query: {
    //             isType: 2,
    //           },
    //         });
    //       }
    //     })
    //     .catch((err) => {
    //       //console.log(err.data)
    //     });
    // },
    // 支付结果
    // goPayresult() {
    //   let _this = this;
    //   //下单

    //   _this
    //     .$post("/order/api/Pay", {
    //       orderId: _this.orderInfo.order_sn,
    //       openId: Lockr.get("openId") || "",
    //     })
    //     .then((res) => {
    //       // console.log(res)
    //       if (res.data.code == 200) {
    //         // console.log(res.data.data.wxParameters)
    //         let wxParameters = res.data.data.wxParameters;
    //         if (wxParameters) {
    //           // 微信支付
    //           _this.payWxPrePay(wxParameters);
    //         } else {
    //           // console.log('积分支付')
    //           _this.$toast.success("支付成功");
    //           _this.$router.replace({
    //             name: "pay-result",
    //             query: {
    //               isType: 1,
    //             },
    //           });
    //         }
    //       } else {
    //         _this.$toast.fail(res.data.message);
    //         _this.$router.replace({
    //           name: "pay-result",
    //           query: {
    //             isType: 2,
    //           },
    //         });
    //       }
    //     })
    //     .catch((err) => {
    //       //console.log(err.data)
    //     });
    // },
    // payWxPrePay(data) {
    //   let _this = this;
    //   // console.log('吊起微信', data)
    //   // console.log('吊起微信', wx)

    //   //       if (res.err_msg == "get_brand_wcpay_request:ok") {
    //   wx.ready(function () {
    //     wx.chooseWXPay({
    //       timestamp: data.timestamp, ////时间戳，自1970年以来的秒数
    //       nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
    //       package: data.package, //这个package是比较坑的他的格式必须是  prepay_id=wx22104854834640694c34f15a1066605800
    //       signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
    //       paySign: data.paySign, // 支付签名
    //       appId: data.appId, //公众号名称，由商户传入
    //       success: function (res) {
    //         // 支付成功后的回调函数
    //         if (res.errMsg === "chooseWXPay:ok") {
    //           _this.$toast("支付成功");
    //           _this.$router.replace({
    //             name: "pay-result",
    //             query: {
    //               isType: 1,
    //             },
    //           });
    //         } else {
    //           // console.log(res, '已调起,支付失败')
    //           _this.$toast("支付失败");
    //           _this.$router.replace({
    //             name: "pay-result",
    //             query: {
    //               isType: 2,
    //             },
    //           });
    //         }
    //       },
    //       fail: function (res) {
    //         // console.log(res, '支付请求失败')
    //         _this.$toast("支付请求失败");
    //         _this.$router.replace({
    //           name: "pay-result",
    //           query: {
    //             isType: 2,
    //           },
    //         });
    //       },
    //       cancel: function (res) {
    //         // console.log(res, '已调起,已取消支付')
    //         _this.$toast("已取消支付");
    //         _this.$router.replace({
    //           name: "order-list",
    //           query: {
    //             active: 1,
    //           },
    //         });
    //         //支付取消
    //       },
    //     });
    //   });

    //   // this.$router.push({
    //   //   name: "pay-result",
    //   //   query: {
    //   //     isType: 1,
    //   //   },
    //   // });
    // },
    clickClose() {
      // console.log('点了遮罩层')
      this.$router.replace({
        name: "order-list",
        query: {
          active: 1,
        },
      });
    },
    // 地址选择弹窗
    onAdderss() {
      this.isAdderssPop = !this.isAdderssPop;
    },
    // 地址修改
    goEdit(e) {
      console.log(e);
      this.$router.push({
        name: "adderss-edit",
        query: {
          isPage: 2,
          id: e.id,
          addsInfo: JSON.stringify(e),
        },
      });
    },
    // 选择支付方式
    // replacePayMethod(val) {
    //   this.isPayMethod = val;
    // },
    // 返回上一页
    onleft() {
      this.$router.go(-1);
    },

    count() {
      let skuItem = [];
      let totalPrice = 0;
      let totalFreightMoney = 0; // freightMoney
      console.log(this.goodsInfo, "商品详情");
      this.goodsInfo.map((item, index) => {
        skuItem.push({
          cart_id: item.cart_id,
          goods_id: item.goods_id,
          sku_id: item.sku_id,
          goods_num: item.amount,
        });
        totalPrice += item.shop_price * item.amount;
        totalFreightMoney =
          totalFreightMoney > item.express_price
            ? totalFreightMoney
            : item.express_price;
      });

      // [{"cart_id":0,"goods_id":2,"sku_id":0,"goods_num":1},{"cart_id":0,"goods_id":1,"sku_id":1,"goods_num":1}]

      this.totalMoney = totalPrice;
      this.skuList = skuItem;
      this.freightMoney = totalFreightMoney;
      // console.log(skuItem)
      //  this.shoppingOrderCreateParams.paymentAmount = Math.round(this.shoppingOrderCreateParams.paymentAmount * 100) / 100;
    },
    // 获取用户积分
    getPoints() {
      let _this = this;

      this.$toast.loading();
      _this.$post("/api/balance").then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          _this.$toast.clear();
          _this.expoints = res.data.data.expoints || 0; //积分
          // this.productInfo.shop_price;
        }
      });
    },
    jsMathFloorSS(e, r) {
      let a = Math.floor(e * 100) / 100;
      let b = Math.floor(r * 100) / 100;
      return a + b;
    },
    jsMathFloor(e) {
      let a = Math.floor(e * 100) / 100;
      return a;
    },
  },
};
</script>
<style lang="scss">
// 轮播图 图标颜色
.confirm-page {
  .van-swipe__indicators {
    .van-swipe__indicator--active {
      background-color: #ff510093 !important;
    }
  }
  .van-stepper {
    .van-stepper__minus {
      color: #ff510093 !important;
      border-color: #ff510093 !important;
    }
    .van-stepper__minus--disabled {
      color: #666666 !important;
      border-color: #666666 !important;
    }
    .van-stepper__plus {
      background-color: #ff510093 !important;
    }
  }
}
</style>

<style lang="scss" scoped>
.confirm-page {
  height: 100%;
  width: 100%;
  background-color: #f9f9f9;
  padding: 50px 0 70px;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE */
  scrollbar-width: none; /* Firefox */
  .mr10 {
    margin-right: 10px;
  }
  .mb20 {
    margin-bottom: 20px;
  }
  /* 没有地址 */
  .no-address {
    margin: 15px 10px;
    height: 45px;
    /* background: palegreen; */
    background-color: #fff;
    box-shadow: 0px 2px 4.5px rgba(69, 79, 99, 0.06);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 25px;
    color: #c64545;
  }
  // 有地址
  .header-address {
    margin: 15px 10px;
    height: 90px;
    text-align: left;
    /* background: palegreen; */
    background-color: #fff;
    box-shadow: 0px 1px 4.5px rgba(69, 79, 99, 0.06);
    border-radius: 5px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /* align-items: center; */

    background-image: url("https://qiniu.zdyxjx.com/minizdyxarrow.png");
    background-repeat: no-repeat;
    background-size: 5px 10px;
    background-position: 95% center;

    .header-address-name {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 20px;
      color: #2a2e43;
      .moren {
        padding: 1px 5px;
        font-size: 10px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 18px;
        color: #ffffff;
        background: #ff5000;
        border-radius: 2.5px;
        margin-right: 5px;
      }
    }

    .header-address-city {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 20px;
      color: #666666;
      white-space: nowrap;
      /*内容超宽后禁止换行显示*/
      overflow: hidden;
      /*超出部分隐藏*/
      text-overflow: ellipsis;
      /*文字超出部分以省略号显示*/
    }

    .header-address-in {
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 30px;
      color: #2a2e43;
      white-space: nowrap;
      /*内容超宽后禁止换行显示*/
      overflow: hidden;
      /*超出部分隐藏*/
      text-overflow: ellipsis;
      /*文字超出部分以省略号显示*/
    }
  }

  /* 商品 */
  .goods {
    margin: 15px 10px;
    padding: 10px;
    background: #ffffff;
    box-shadow: 0px 1px 4.5px rgba(69, 79, 99, 0.06);
    border-radius: 5px;
    // background-color: paleturquoise;
    text-align: left;

    .goods-info-block {
      .goods-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      // background-color: papayawhip;

      /* height: 250rpx; */
    }

    .img {
      width: 125px;
      height: 125px;
    }
    .img .van-image,
    image {
      width: 100%;
      height: 100%;
    }

    .info-block {
      /* padding: 20rpx; */
      /* background-color: #fff; */
      width: 200px;
    }

    .name {
      width: 100%;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 30px;
      color: #454f63;
      white-space: nowrap;
      /*内容超宽后禁止换行显示*/
      overflow: hidden;
      /*超出部分隐藏*/
      text-overflow: ellipsis;
      /*文字超出部分以省略号显示*/
    }

    .desc {
      width: 100%;
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 17px;
      color: #78849e;
      white-space: nowrap;
      /*内容超宽后禁止换行显示*/
      overflow: hidden;
      /*超出部分隐藏*/
      text-overflow: ellipsis;
      /*文字超出部分以省略号显示*/
    }

    .udc {
      display: inline-block;
      background: #f9f9f9;
      padding: 2.5px 10px;

      border-radius: 5px;

      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 17px;
      color: #bbbbbb;
    }

    .price-block {
      margin-top: 10px;
      font-size: 17px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 26px;
      color: #78849e;
    }

    .price-tips {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 20px;
      color: #cccccc;
      text-decoration: line-through;
    }

    .price {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 25px;
      color: #ff5000;
    }

    .total-block {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 5px 0;
    }

    .total-left {
      width: 45%;
      text-align: center;
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 20px;
      color: #454f63;
      p {
        display: inline-block;
      }
    }

    .total-tips {
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 17px;
      color: #999999;
      margin-right: 10px;
    }

    .total-right {
      width: 45%;
      text-align: right;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 26px;
      color: #ff5000;
      span {
        font-size: 12px;
      }
    }
    // 步进器
    .goods-num {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 5px 0;
      .num-title {
        width: 60%;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 26px;
        color: #999999;
        letter-spacing: 1px;
        text-align: center;
      }
    }
  }

  /* 留言 */
  .input-block {
    margin: 0 10px;
    // height: 92px;
    padding: 10px;
    background-color: #fff;
    box-shadow: 0px 1px 4.5px rgba(69, 79, 99, 0.06);
    border-radius: 5px;
    /* width: 100%; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* align-items: center; */
    .tips {
      text-align: left;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 20px;
      color: #cccccc;
    }
  }

  /* 邮费 */
  /* cell */

  .goods-cell {
    background-color: #fff;
    margin: 10px 10px 0;
    box-shadow: 0px 1px 4.5px rgba(69, 79, 99, 0.06);
    border-radius: 5px;

    .cell-block {
      display: flex;
      min-height: 45px;
      justify-content: space-between;
      border-bottom: 1px solid #f9f9f9;
    }
    .cell-tips {
      margin-right: 10px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 20px;
      color: #999999;
    }
    .cell-title {
      width: 40%;

      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 25px;
      color: #454f63;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      /* margin-right: 50rpx; */
    }

    .cell-center {
      width: 50%;
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      line-height: 25px;
      color: #ff5000;
      padding-right: 15px;
      /* background-color: #fff; */
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }

  /* 底部按钮 */
  .foot-block {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 45px;
    background-color: #ffffff;
    border-top: 1px solid #f9f9f9;
    display: flex;
    align-items: center;
    justify-content: space-around;

    .btn {
      width: 157px;
      height: 40px;
      background: #eeeeee;
      opacity: 1;
      border-radius: 20px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 20px;
      color: #cccccc;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .pay {
      background: #ff5000;
      color: #ffffff;
    }
    .foot-left {
      /* background-color: peachpuff; */
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      line-height: 26px;
      color: #ff5000;
    }
    .foot-icon {
      font-size: 12px;
    }
    .foot-tips {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 25px;
      color: #454f63;
    }
  }

  /* 遮罩层 */
  .mask {
    position: fixed;
    top: 0;
    z-index: 6;
    height: 100%;
    width: 100%;
    background-color: #000;
    opacity: 0.5443;
  }
  .popup {
    position: fixed;
    bottom: 0;
    z-index: 10;
    height: 80%;
    width: 100%;
    background-color: #fff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .pop-cols {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 40px;
      box-sizing: border-box;
      font-size: 25px;
      color: #999;
      padding: 0 10px;
      text-align: right;
      line-height: 45px;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      /* background-color: #eee; */
      z-index: 999;
    }
    /* 新增地址 */
    .on-top {
      position: absolute;
      bottom: 5px;
      left: 0;
      width: 100%;
      height: 40px;
      box-sizing: border-box;
      background-color: #ff5000;
      border-radius: 5px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 30px;
    }
    .adderss-action {
      height: 450px;
      position: relative;
      top: 40px;
      overflow-y: scroll;
      overflow-x: hidden;
      // padding-bottom: 50px;
      background-color: #f9f9f9;
    }
    .no-list {
      background-image: url("https://qiniu.zdyxjx.com/minizdyxaddress.png");
      background-repeat: no-repeat;
      background-size: 90% 100%;
      background-position: center center;
    }
    .adderss-radio {
      height: 85px;
      background-color: #fff;
      margin: 5px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
    }
    .radio {
      width: 17px;
      height: 17px;
      .radio-icon {
        width: 100%;
        height: 100%;
      }
    }

    .adderss-action-item {
      text-align: left;
      width: 250px;
      /* background-color: peachpuff; */
      border-right: 1px solid #cccccc;
    }
    .adderss-action-text {
      width: 100%;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 18px;
      color: #454f63;
      white-space: nowrap;
      /*内容超宽后禁止换行显示*/
      overflow: hidden;
      /*超出部分隐藏*/
      text-overflow: ellipsis;
      /*文字超出部分以省略号显示*/
    }
    .adderss-action-name {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      /* line-height: 28rpx; */
      color: #2a2e43;
    }
    .adderss-action-phone {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      /* line-height: 28rpx; */
      color: #2a2e43;
    }
    .moren {
      padding: 1px 5px;
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 18px;
      color: #ffffff;
      background: #ff5000;
      border-radius: 2.5px;
      margin-right: 5px;
    }
    .edit {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 15px;
      color: #78849e;
    }
  }
  // 支付弹窗
  .pop-pay-header {
    h3 {
      margin-top: 10px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 30px;
      color: #2a2e43;
      letter-spacing: 1px;
    }
    .pop-pay-price {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      line-height: 41px;
      color: #ff5000;
      letter-spacing: 1px;
      span {
        font-size: 12px;
      }
    }
    .pop-pay-time {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 25px;
      color: #666666;
      letter-spacing: 1px;
      display: flex;
      align-items: center;
      justify-content: center;

      .colon {
        display: inline-block;
        margin: 0 4px;
      }
      .block {
        display: inline-block;
        width: 22px;
        font-size: 12px;
        text-align: center;
        background-color: #eee;
        border-radius: 5px;
      }
    }
  }
  .pop-pay-center {
    padding: 20px 10px;
    background-color: #f9f9f9;
    .pop-pay-cell {
      height: 44px;
      background-color: #fff;
      border-radius: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
      .pop-pay-left {
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 26px;
        color: #333333;
        letter-spacing: 1px;
      }
      .radio {
        width: 17px;
        height: 17px;
        .radio-icon {
          display: block;
          width: 100%;
        }
      }
    }
  }
  .pop-pay-btn-block {
    position: absolute;
    bottom: 30px;
    left: 0;
    width: 100%;
    height: 49px;
    padding: 5px 0;
    background-color: #fff;
    // background-color: palegreen;
    .pop-pay-btn {
      background-color: #ff5000;
      font-size: 12px;
      border-radius: 20px;
      width: 80%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 21px;
      color: #ffffff;
    }
  }
}
.btn-a:active {
  transform: scale(0.98);
  -webkit-transform: scale(0.98);
  -moz-transform: scale(0.98);
}
.btnC:active {
  background-color: rgba(255, 80, 0, 0.7) !important;
}

.address-block {
  margin: 10px 10px;
  // height: 92px;
  padding: 10px;
  background-color: #fff;
  box-shadow: 0px 1px 4.5px rgba(69, 79, 99, 0.06);
  border-radius: 5px;
  /* width: 100%; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
}
</style>
